module.exports = __webpack_public_path__ + "static/logo_tinaba_colore_orizzontale-b7e95e37455e09d709fec579fae8523c.svg";